import * as React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import {
  MenuItem,
  Collapse,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import styles from './styles';
import { getVersionDetails } from '../../../../store/actions/authorization';
import { useDispatch } from 'react-redux';

export const NavSubMenuItems = (props) => {
  const {
    parentLabel,
    subMenu,
    index,
    selectedIndex,
    handleCloseNav,
    category,
    depth = 1,
  } = props;
  const classes = styles();
  const location = useLocation();
  const dispatch = useDispatch();
  const [openSubmenus, setOpenSubmenus] = React.useState({});
  const [searchParams] = useSearchParams();
  const collection = searchParams.get('col');

  const toggleSubmenu = (label) => {
    if (!openSubmenus?.Versions && label === 'Versions') {
      dispatch(getVersionDetails());
    }
    setOpenSubmenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const hasActiveSubmenu = (menuItem) => {
    if (!menuItem.submenu) return false;

    return menuItem.submenu.some(sub => {
      if (sub.link && location.pathname.startsWith(sub.link)) {
        return true;
      }
      return hasActiveSubmenu(sub);
    });
  };

  return (
    <Collapse in={index === selectedIndex} timeout="auto">
      {subMenu.map((item) => {
        const hasChildren = Array.isArray(item.submenu);
        const isOpen = openSubmenus[item.label] ?? false;
        const isSelected = (item.link && location.pathname.startsWith(item.link)) || hasActiveSubmenu(item);

        return (
          <React.Fragment key={`${parentLabel}_submenu_${item.label}`}>
            {hasChildren
              ? (
              <>
                <MenuItem
                  onClick={() => toggleSubmenu(item.label)}
                  className={classes.subMenuItemText}
                  selected={isSelected}
                  sx={{ pr: 0, pl: depth * 2, display: 'flex', justifyContent: 'space-between' }}
                >
                  {item.label}
                  {isOpen ? <ExpandLess /> : <ExpandMore />}
                </MenuItem>
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                  <NavSubMenuItems
                    parentLabel={item.label}
                    subMenu={item.submenu}
                    index={index}
                    selectedIndex={selectedIndex}
                    handleCloseNav={handleCloseNav}
                    category={category}
                    depth={depth + 1}
                  />
                </Collapse>
              </>
                )
              : (
              <Link
                to={item.link}
                onClick={handleCloseNav}
                className={classes.subMenuItem}
                state={parentLabel === 'Assets' && item}
              >
                <MenuItem
                  className={classes.subMenuItemText}
                  sx={{
                    pl: depth * 2,
                    color:
                      category === item.label || (location.pathname.includes(item?.parentLabel) && collection === item.label)
                        ? 'rgb(0 86 153) !important'
                        : '#000',
                  }}
                >
                  {item.label}
                </MenuItem>
              </Link>
                )}
          </React.Fragment>
        );
      })}
    </Collapse>
  );
};

NavSubMenuItems.propTypes = {
  parentLabel: PropTypes.string.isRequired,
  subMenu: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  selectedIndex: PropTypes.number,
  handleCloseNav: PropTypes.func.isRequired,
  category: PropTypes.string,
  depth: PropTypes.number,
};
